import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
} from '@mui/material';
import { useState } from 'react';

const testimonials = [
  {
    id: 1,
    name: 'Derek Taylor',
    position: 'Director of Technology, Implementation and Operations, T3 Sixty',
    testimonial:
      'Oppy is a game changer for our brokerage. It consistently conducts meaningful conversations with potential clients and customers, saving us countless hours. Their white glove setup helped us achieve fast success',
    avatar:
      'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: 2,
    name: 'Tyler B',
    position: 'Marketing Director at Metro Brokers',
    testimonial:
      'This integration has transformed our lead quality. We now get more qualified leads and can focus on what they do best - closing deals and serving clients.',
    avatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: 3,
    name: 'Sarah Johnson',
    position: 'Real Estate Agent at Prime Properties',
    testimonial:
      'The automation capabilities are incredible. Our response time has improved dramatically, and clients appreciate the immediate engagement.',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: 4,
    name: 'Michael Chen',
    position: 'Broker Owner at Apex Realty',
    testimonial:
      'ROI has been exceptional. The system pays for itself within the first month through improved conversion rates and time savings.',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
  },
  {
    id: 5,
    name: 'Emma Rodriguez',
    position: 'Team Lead at Coastal Properties',
    testimonial:
      'Our team productivity has increased by 300%. The AI handles initial conversations so well that prospects are warm by the time we connect.',
    avatar:
      'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop&crop=face',
  },
];

const CARD_WIDTH = 400;
const CARD_GAP = 32; // px
const VISIBLE_SIDE = 96; // quanto aparece do card vizinho

export default function TestimonialsCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => setActiveIndex((i) => Math.max(i - 1, 0));
  const handleNext = () =>
    setActiveIndex((i) => Math.min(i + 1, testimonials.length - 1));

  return (
    <Box
      sx={{
        width: `${CARD_WIDTH + VISIBLE_SIDE * 2}px`,
        mx: 'auto',
        overflow: 'hidden', // ESSENCIAL: mascara tudo fora da área branca
        borderRadius: '20px',
        p: 0,
        position: 'relative',
      }}
    >
      {/* CARDS */}
      <Box
        sx={{
          display: 'flex',
          transition: 'transform 0.5s cubic-bezier(.7,0,.3,1)',
          gap: `${CARD_GAP}px`,
          minHeight: '400px',
          willChange: 'transform',
          py: 6,
          px: 0,
          // Centraliza o card ativo
          transform: `translateX(calc(${
            VISIBLE_SIDE - (CARD_WIDTH + CARD_GAP) * activeIndex
          }px))`,
        }}
      >
        {testimonials.map((item, idx) => (
          <Card
            key={item.id}
            sx={{
              background: '#fff',
              borderRadius: '20px',
              width: `${CARD_WIDTH}px`,
              minWidth: `${CARD_WIDTH}px`,
              boxShadow:
                idx === activeIndex
                  ? '0 8px 32px rgba(41,56,118,0.12)'
                  : '0 2px 8px rgba(41,56,118,0.04)',
              transition: 'box-shadow .3s, scale .3s, opacity .3s',
              scale: idx === activeIndex ? '1.01' : '0.96',
              opacity: idx === activeIndex ? 1 : 0.7,
              zIndex: idx === activeIndex ? 2 : 1,
              border:
                idx === activeIndex ? '2px solid #ecebfd' : '1px solid #ecebfd',
            }}
          >
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                alignItems: 'flex-start',
                px: 3,
                py: 2,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar
                  src={item.avatar}
                  alt={item.name}
                  sx={{
                    width: 40,
                    height: 40,
                    bgcolor: '#ecebfd',
                    color: '#283871',
                  }}
                />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: 'Space Grotesk',
                      fontSize: '16px',
                      lineHeight: '33.6px',
                      fontWeight: 600,
                      color: '#000',
                    }}
                  >
                    {item.name}
                  </Typography>
                </Box>
              </Box>
              <Typography
                fontSize={14}
                color="#000"
                sx={{
                  fontWeight: 400,
                  lineHeight: '20px',
                  fontFamily: 'Space Grotesk',
                }}
              >
                {item.position}
              </Typography>
              <Typography
                sx={{
                  fontSize: '12px',
                  color: '#424242',
                  mt: 1,
                  fontFamily: 'Space Grotesk',
                  fontWeight: 400,
                  lineHeight: '25.6px',
                  verticalAlign: 'middle',
                }}
              >
                “{item.testimonial}”
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Box>

      {/* Botões centralizados abaixo */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          gap: 2,
          position: 'absolute',
          bottom: 5,
          left: 0,
          pointerEvents: 'none',
        }}
      >
        <IconButton
          aria-label="Anterior"
          onClick={handlePrev}
          disabled={activeIndex === 0}
          sx={{
            pointerEvents: 'all',
            background: '#fff',
            color: '#283871',
            border: '1px solid #ecebfd',
            boxShadow: '0 2px 6px rgba(41,56,118,0.09)',
            transition: '.2s',
            '&:hover': { background: '#ecebfd' },
            opacity: activeIndex === 0 ? 0.3 : 1,
          }}
        >
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>
        <IconButton
          aria-label="Próximo"
          onClick={handleNext}
          disabled={activeIndex === testimonials.length - 1}
          sx={{
            pointerEvents: 'all',
            background: '#fff',
            color: '#283871',
            border: '1px solid #ecebfd',
            boxShadow: '0 2px 6px rgba(41,56,118,0.09)',
            transition: '.2s',
            '&:hover': { background: '#ecebfd' },
            opacity: activeIndex === testimonials.length - 1 ? 0.3 : 1,
          }}
        >
          <ArrowForwardIosIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
